<template>
	<div class="textarea-wrapper" :class="input.class">
		<textarea
			v-model="value"
			:class="{
		'error': !isValid,
		'success': isValid,
		'uppercase': this.input.textTransform == 'uppecase',
		'lowercase': this.input.textTransform == 'lowercase'
		}"
			:name="input.name"
			:maxlength="input.maxChars"
			@blur="[updateValidationStatus(), validateInput(), textTransform()]"
		></textarea>
		<div class="textarea-info">
			<span class="price" v-if="input.price > 0" v-text="formatPrice(input.price)"></span>
			<span class="char-limit" v-if="input.maxChars > 0">Maximum {{ input.maxChars }} characters <span v-if="showCharsLeft">({{ charsLeft }} remaining)</span></span>
		</div>
		<div class="error-message" v-if="this.errorMessage">{{this.errorMessage}}</div>
	</div>
</template>

<script>
import InputText from "./InputText";
import helper from "@/mixins/helper.js";

export default {
	name: "InputTextarea",
	extends: InputText,
	computed: {
		showCharsLeft: function() {
			return this.input.maxChars ? this.charsLeft < this.input.maxChars : false;
		},
		charsLeft: function() {
			return this.input.maxChars ? this.input.maxChars - this.value.length : null;
		}
	}
};
</script>

<style lang="scss">
.textarea-wrapper {
	textarea {
		padding: 16px;
		width: 100%;
		min-height: 100px;

		&.error {
			border: 2px solid #f00;
		}

		&.uppercase {
			text-transform: uppercase;
		}

		&.lowercase {
			text-transform: lowercase;
		}
	}

	.textarea-info {
		display: flex;
		justify-content: space-between;
		padding: 4px 0;
		margin-bottom: 16px;

		.char-limit {
			text-align: right;
			flex: 1;
		}

	}

	.required-field,
	.error-message {
		color: #f00;
		margin-top: 8px;
	}
}
</style>